import { useEffect, useRef } from "react";

import { useApiClient } from "../../api-client";
import { useLang } from "../../i18n";

export const UnsignedAgreement = () => {
  const lang = useLang();
  const iframe = useRef<HTMLIFrameElement>(null);
  const { get } = useApiClient();

  useEffect(() => {
    const getPdf = async () => {
      const { data: pdf } = await get(
        `/v1/employees/unsigned-novation-contract?lang=${lang}`
      );

      const file = window.URL.createObjectURL(pdf);
      if (iframe.current) {
        iframe.current.src = file;
      }
    };
    getPdf();
  }, []);

  return (
    <div>
      <iframe
        data-testid="pdf-iframe"
        src=""
        className="h-screen w-full"
        ref={iframe}
      ></iframe>
    </div>
  );
};
